import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function SwollenLegsHeroSection() {
  return <section className="relative w-full pt-2 pb-12 sm:pt-3 sm:pb-20 md:pb-24 lg:pb-12" style={{
    backgroundColor: '#FFFFFF'
  }} data-id="element-1286">
      {/* Background subtle gradient */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-ginger-light/5 to-transparent pointer-events-none" data-id="element-1287" />

      {/* Decorative blur element */}
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-ginger/5 rounded-full blur-3xl pointer-events-none" data-id="element-1288" />

      <div className="max-w-7xl mx-auto px-6 w-full grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-1289">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center sm:items-start text-center sm:text-left z-10" data-id="element-1290">
          {/* Trust Bar Pill */}
          <div className="mb-3 sm:mb-4 w-full flex justify-center sm:justify-start" data-id="element-1291">
            <div className="bg-[#D6ECD6] rounded-[20px] py-[14px] px-[14px] sm:py-[18px] sm:px-[20px] inline-flex items-center gap-3 sm:gap-[18px] max-w-[600px]" data-id="element-1292">
              {/* Avatar Stack */}
              <div className="flex items-center flex-shrink-0" data-id="element-1293">
                {['https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=120&h=120&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1557862921-37829c790f19?w=120&h=120&fit=crop&crop=faces', 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=120&h=120&fit=crop&crop=faces'].map((src, i) => <div key={i} className="w-[48px] h-[48px] sm:w-[62px] sm:h-[62px] rounded-full border-[3px] border-[#D6ECD6] overflow-hidden flex-shrink-0 shadow-md" style={{
                marginLeft: i === 0 ? 0 : '-14px',
                zIndex: 3 - i
              }} data-id="element-1294">
                    <img src={src} alt={`GINEXT customer, woman ${67 - i * 6}`} className="w-full h-full object-cover object-top" loading="eager" data-id="element-1295" />
                  </div>)}
              </div>

              {/* Right Content */}
              <div className="flex flex-col gap-[5px] sm:gap-[7px] min-w-0" data-id="element-1296">
                {/* Stars: 4 full + 1 at 80% */}
                <div className="flex items-center gap-[3px]" aria-label="4.8 out of 5 stars" data-id="element-1297">
                  {[...Array(4)].map((_, i) => <svg key={i} className="w-[22px] h-[22px] sm:w-[30px] sm:h-[30px]" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1298">
                      <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#E8720C" data-id="element-1299" />
                    </svg>)}
                  {/* 5th star: 80% filled */}
                  <svg className="w-[22px] h-[22px] sm:w-[30px] sm:h-[30px]" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1300">
                    <defs data-id="element-1301">
                      <clipPath id="trustFill80" data-id="element-1302">
                        <rect x="0" y="0" width="19.2" height="24" data-id="element-1303" />
                      </clipPath>
                    </defs>
                    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#C8B8A0" data-id="element-1304" />
                    <path d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z" fill="#E8720C" clipPath="url(#trustFill80)" data-id="element-1305" />
                  </svg>
                </div>

                {/* Stats Text */}
                <div className="text-[13px] sm:text-[clamp(14px,2.8vw,18px)] text-[#1A1A1A] leading-[1.3] whitespace-nowrap sm:whitespace-nowrap" data-id="element-1306">
                  <strong className="font-extrabold" data-id="element-1307">4.8 stars</strong>
                  <span className="text-[#5A7A5A] mx-1.5 font-normal" data-id="element-1308">|</span>
                  <strong className="font-extrabold" data-id="element-1309">10K+</strong> reviews
                  <span className="text-[#5A7A5A] mx-1.5 font-normal" data-id="element-1310">|</span>
                  <strong className="font-extrabold" data-id="element-1311">10K+</strong> members
                </div>
              </div>
            </div>
          </div>

          <div className="inline-block px-4 py-1.5 mb-4 sm:mb-5 border border-ginger/20 rounded-full bg-white/50 backdrop-blur-sm shadow-sm mx-auto sm:mx-0" data-id="element-1312">
            <span className="text-ginger font-medium text-xs tracking-[0.3em] uppercase" data-id="element-1313">
              America's #1 Ginger Oil
            </span>
          </div>

          {/* Badge */}

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-charcoal leading-[1.1] mb-4 sm:mb-6 tracking-tight" data-id="element-1314">
            By Evening, Your Legs Aren't Tired{' '}
            <span className="text-ginger font-normal block mt-2" data-id="element-1315">
              They're Holding Pressure
            </span>
          </h1>

          <p className="text-sm sm:text-base lg:text-lg text-charcoal-light/90 mb-6 sm:mb-8 leading-relaxed font-light max-w-xl mx-auto sm:mx-0" data-id="element-1316">
            Tight ankles, lingering sock marks, and heavy legs are signs
            circulation has slowed. The right warmth helps your body release
            pressure — not freeze it.
          </p>

          {/* Hero Image - Mobile Only */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.1,
          ease: 'easeOut'
        }} className="relative w-full mb-6 sm:mb-8 lg:hidden" data-id="element-1317">
            <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl shadow-ginger/10" data-id="element-1318">
              <img src="https://cdn.magicpatterns.com/uploads/avxXdHm973XVSypaF5JSKo/hero_img_3_mobile.png" alt="GINEXT Ginger Oil with circulation benefits" className="w-full h-auto" loading="eager" data-id="element-1319" />
            </div>
          </motion.div>

          <div className="w-full sm:w-auto lg:w-full flex justify-center sm:justify-start" data-id="element-1320">
            <a href="#bundles" className="block scroll-smooth w-full sm:w-auto lg:w-full" data-id="element-1321">
              <motion.div whileHover={{
              scale: 1.02,
              boxShadow: '0 20px 40px -10px rgba(232, 119, 34, 0.3)'
            }} whileTap={{
              scale: 0.98
            }} className="w-full sm:w-auto lg:w-full group bg-ginger text-white px-8 sm:px-10 lg:px-12 py-4 sm:py-5 lg:py-6 rounded-xl font-normal text-base sm:text-lg lg:text-xl shadow-xl shadow-ginger/20 transition-all duration-300" data-id="element-1322">
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-1323">
                  <span data-id="element-1324">Try GINEXT Risk-Free</span>
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 group-hover:translate-x-1 transition-transform" data-id="element-1325" />
                </div>
                <p className="text-xs sm:text-sm lg:text-base font-light text-white/90 text-center tracking-wide" data-id="element-1326">
                  30 Days Money Back Guaranteed
                </p>
              </motion.div>
            </a>
          </div>

          {/* Trust Stats - Below CTA */}
          <div className="mt-3 sm:mt-4 flex flex-col items-center sm:items-start gap-1" data-id="element-1327">
            <div className="flex items-center gap-[2px]" aria-label="4.8 out of 5 stars" data-id="element-1328">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-ginger text-ginger" data-id="element-1329" />)}
            </div>
            <p className="text-xs sm:text-sm text-charcoal-light" data-id="element-1330">
              <strong className="font-semibold text-charcoal" data-id="element-1331">4.8 stars</strong>
              <span className="mx-1.5 text-charcoal-light/50" data-id="element-1332">|</span>
              <strong className="font-semibold text-charcoal" data-id="element-1333">10K+</strong>{' '}
              reviews
              <span className="mx-1.5 text-charcoal-light/50" data-id="element-1334">|</span>
              <strong className="font-semibold text-charcoal" data-id="element-1335">10K+</strong>{' '}
              members
            </p>
          </div>
        </motion.div>

        {/* Desktop Hero Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.9,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="hidden lg:block relative" data-id="element-1336">
          <div className="relative w-full overflow-hidden rounded-3xl shadow-2xl shadow-ginger/20" data-id="element-1337">
            <img src="https://cdn.magicpatterns.com/uploads/avxXdHm973XVSypaF5JSKo/hero_img_3_mobile.png" alt="GINEXT Ginger Oil - Natural circulation support" className="w-full h-auto transform hover:scale-105 transition-transform duration-700" loading="eager" data-id="element-1338" />
          </div>

          {/* Floating accent element */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-ginger/10 rounded-full blur-2xl pointer-events-none" data-id="element-1339" />
        </motion.div>
      </div>

      {/* Value Prop Card */}
      <div className="max-w-7xl mx-auto px-6 mt-12 sm:mt-16 lg:hidden" data-id="element-1340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-[#FDE8D0] rounded-2xl p-7 sm:p-9 max-w-[560px] mx-auto sm:mx-0" data-id="element-1341">
          <h2 className="text-[clamp(28px,6vw,40px)] font-black text-[#1A1A1A] leading-[1.12] mb-7" data-id="element-1342">
            You Have Circulation Gaps.&nbsp;
            <span className="text-ginger" data-id="element-1343">GINEXT Fixes Them.</span>
          </h2>

          <ul className="list-none mb-7 flex flex-col gap-4" data-id="element-1344">
            {['100% Botanical Formula. 4 Clinically-Studied Ingredients.', 'Deep Warming Relief. 3× Faster Than Leading Topical Creams.', 'Third-Party Tested & Dermatologist Reviewed.'].map((item, i) => <li key={i} className="flex items-start gap-3.5 text-[clamp(16px,3.5vw,19px)] text-[#1A1A1A] leading-[1.4]" data-id="element-1345">
                <svg className="shrink-0 w-7 h-7 mt-px" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1346">
                  <circle cx="14" cy="14" r="14" fill="#E8720C" data-id="element-1347" />
                  <path d="M8 14.5l4 4 8-8" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" data-id="element-1348" />
                </svg>
                {item}
              </li>)}
          </ul>

          <p className="text-[clamp(16px,3.5vw,19px)] font-extrabold text-[#1A1A1A] leading-[1.4]" data-id="element-1349">
            No Menthol. No Cold Shock. No Greasy Film. Just Daily Warming
            Relief.
          </p>
        </motion.div>
      </div>
    </section>;
}